import script from "./NewsPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./NewsPage.vue?vue&type=script&setup=true&lang=ts"

import "./NewsPage.vue?vue&type=style&index=0&id=4645e806&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4645e806"]])

export default __exports__